import React, { useEffect } from "react";
import { Select, Card, Row, Col, Typography } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { filtersSaga } from "./saga";
import * as selectors from "./selectors";

const { Text } = Typography;

export default function Filters({
  selectedLab = null,
  selectedClient = null,
  selectedProject = null,
  handleClientChange = () => {},
  handleProjectChange = () => {},
  handleLabChange = () => {},
  userRole,
}) {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: filtersSaga });

  const dispatch = useDispatch();
  const clients = useSelector(selectors.selectClients);
  const projects = useSelector(selectors.selectProjects);
  const labs = useSelector(selectors.selectLabs);

  useEffect(() => {
    if (userRole !== "company_admin" && userRole !== "regulatory_body_admin" && userRole !== "csc_admin") {
      dispatch(actions.fetchClients());
    }
    dispatch(actions.fetchLabs());
  }, [dispatch, userRole]);

  useEffect(() => {
    if (selectedClient) {
      const query = `companyId=${selectedClient}`;
      dispatch(actions.fetchProjects({ query }));
    }
  }, [selectedClient, dispatch]);

  return (
    <Card>
      <Row gutter={[16, 16]} align="middle" wrap={false}>
        <Col>
          <FilterOutlined style={{ fontSize: 20, color: "#0D9488" }} />
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Text strong>Labs</Text>
          <Select
            showSearch
            placeholder="Select Lab"
            style={{ width: "100%", marginTop: 4 }}
            options={labs || []}
            value={selectedLab}
            onChange={handleLabChange}
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          />
        </Col>
        {userRole === "company_admin" ||
        userRole === "regulatory_body_admin" ||
        userRole === "csc_admin" ? null : (
          <Col xs={24} sm={12} md={6}>
            <Text strong>Client</Text>
            <Select
              showSearch
              value={selectedClient}
              placeholder="Select Client"
              style={{ width: "100%", marginTop: 4 }}
              options={clients || []}
              onChange={handleClientChange}
              optionFilterProp="label"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </Col>
        )}
        <Col xs={24} sm={12} md={6}>
          <Text strong>Project</Text>
          <Select
            showSearch
            placeholder="Select Project"
            style={{ width: "100%", marginTop: 4 }}
            options={projects || []}
            value={selectedProject}
            onChange={handleProjectChange}
            optionFilterProp="label"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          />
        </Col>
      </Row>
    </Card>
  );
}